<template>
  <div class="card card-profile shadow mb-3">
    <div class="text-center mt-5">
      <div class="card-profile-image-custom">
        <img
          src="/img/pages/call.png"
          width="140"
          :alt="process.title"
          :title="process.title"
        />
      </div>
      <div class="card-header text-center border-0 mt-7 pb-1">
        <h2 class="text-warning mb-0">{{ process.title }}</h2>
      </div>
    </div>
    <div class="card-body pt-0 pb-1">
      <div class="row">
        <div class="col-12">
          <div
            class="card-profile-stats d-flex justify-content-center pt-1"
            v-if="process.external_link"
          >
            <div>
              <span
                class="text-capitalize btn btn-link p-0 m-0 cursor-pointer text-primary heading"
                title="Abrir página"
                @click="openLink(process.external_link)"
                >Visualizar</span
              >
              <span class="description">Mais informações</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row text-center mb-3" v-if="process.keywords">
        <div class="col-12">
          <h3>
            Palavras-chave:
            <span class="font-weight-light">
              <base-button
                size="sm"
                class="cursor-inherit"
                v-for="(keyword, index) in process.keywords"
                :key="'sector_' + index"
                :type="bgClasses[index % bgClasses.length]"
              >
                {{ keyword }}
              </base-button>
            </span>
          </h3>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-12">
          <h3 v-if="process.region">
            Região:
            <span class="font-weight-light">
              {{ process.region }}
            </span>
          </h3>
          <h3>
            <span v-if="process.end_date">
              Período das aplicações:
              <span class="font-weight-light">
                {{
                  process.start_date
                    ? formatDate(process.start_date, "ll")
                    : "..."
                }}
                até
                {{ formatDate(process.end_date, "ll") }}
              </span>
            </span>
            <span v-else>
              Início das aplicações:
              <span class="font-weight-light">
                {{
                  process.start_date
                    ? formatDate(process.start_date, "ll")
                    : "..."
                }}
                <span v-if="process.start_date"> (fluxo contínuo)</span>
              </span>
            </span>
          </h3>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-lg-10 offset-lg-1 mt-2 text-center"
          v-if="process.description || process.observation"
        >
          <hr class="mt-1 mb-4" />
          <p class="small text-left" v-if="process.description">
            <span class="font-weight-bold">&#8226; Descrição:</span>
            {{ process.description }}
          </p>
          <p class="small text-left" v-if="process.observation">
            <span class="font-weight-bold">&#8226; Observações:</span>
            {{ process.observation }}
          </p>
        </div>
      </div>
    </div>
    <slot name="footer">
      <div class="card-footer text-center">
        <base-alert v-if="process.status === 'closed'" class="mb-0"
          >Inscrições encerradas!</base-alert
        >
        <small>
          <i class="fas fa-info-circle mr-1"></i>
          Os dados informados na inscrição serão analisados e utilizados como
          critérios de seleção no programa <b>{{ process.title }}</b
          >.
        </small>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: "programa-tab",
  props: {
    process: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bgClasses: [
        "info",
        "primary",
        "danger",
        "success",
        "secondary",
        "warning",
        "light",
        "dark",
      ],
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
  },
};
</script>

<style scoped>
.cursor-inherit:hover,
.cursor-inherit:active,
.cursor-inherit:focus {
  cursor: inherit;
}

.cursor-pointer {
  cursor: pointer;
}

.card-profile-image-custom img {
  -webkit-transform: translate(-50%, -30%);
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}
.card-profile-image-custom img:hover {
  -webkit-transform: translate(-50%, -33%);
  transform: translate(-50%, -33%);
}
</style>
